import { render, staticRenderFns } from "./AiConsultEmbed.vue?vue&type=template&id=7b4a5d41&scoped=true"
import script from "./AiConsultEmbed.vue?vue&type=script&lang=js"
export * from "./AiConsultEmbed.vue?vue&type=script&lang=js"
import style0 from "./AiConsultEmbed.vue?vue&type=style&index=0&id=7b4a5d41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4a5d41",
  null
  
)

export default component.exports